import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import CustomSelect from "../../Components/common/CustomSelect/CustomSelect";
import Modal from "../../Components/UI/Modal/Modal";
import LogWindow from "./components/LogWindow";

import { RequestIndexes, RequestPefDevices } from "../../store/actions/zsearchActions";

import "./styles.scss";

const timeIntervalOptions = [
  {
    id: "last3h",
    value: "Last 3 Hours",
  },
  {
    id: "last1d",
    value: "Last 1 Day",
  },
  {
    id: "last3d",
    value: "Last 3 Days",
  },
  {
    id: "last7d",
    value: "Last 7 Days",
  },
  {
    id: "last30d",
    value: "Last 30 Days",
  },
  {
    id: "last60d",
    value: "Last 60 Days",
  },
];

const mgwProcessOptions = [
  {
    id: "postfix/relay/smtp",
    value: "postfix/relay/smtp",
  },
  {
    id: "postfix/cleanup",
    value: "postfix/cleanup",
  },
];

const getTimeRange = (selectedRange) => {
  const now = new Date();
  let fromTime;

  switch (selectedRange) {
    case "last3h":
      fromTime = new Date(now.getTime() - 3 * 60 * 60 * 1000); // 3 hours ago
      break;
    case "last1d":
      fromTime = new Date(now.getTime() - 24 * 60 * 60 * 1000); // 1 day ago
      break;
    case "last3d":
      fromTime = new Date(now.getTime() - 3 * 24 * 60 * 60 * 1000); // 3 days ago
      break;
    case "last7d":
      fromTime = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000); // 7 days ago
      break;
    case "last30d":
      fromTime = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000); // 30 days ago
      break;
    case "last60d":
      fromTime = new Date(now.getTime() - 60 * 24 * 60 * 60 * 1000); // 60 days ago
      break;
    default:
      return null; // No time filter applied
  }

  return fromTime.toISOString(); // Convert to ISO format for ZincSearch
};

//const WINDOW_FEATURES = "width=1320,height=900";

const Logs = () => {
  const dispatch = useDispatch();

  const [modalActive, setModalActive] = useState(false);

  const [selectedTimeInterval, setSelectedTimeInterval] = useState(null);
  const [maxResult, setMaxResult] = useState("1000");

  const mgwDevices = useSelector((state) => state.zsearch.mgwDevices);
  const mgwDevicesLoading = useSelector((state) => state.zsearch.mgwDevicesLoading);
  const [mgwKeyword, setMgwKeyword] = useState("");
  const [mgwSelectedProcess, setMgwSelectedProcess] = useState(null);
  const [mgwSelectedDevice, setMgwSelectedDevice] = useState(null);

  const pefEndpoints = useSelector((state) => state.zsearch.pefEndpoints);
  const pefDevices = useSelector((state) => state.zsearch.pefDevices);
  const pefDevicesLoading = useSelector((state) => state.zsearch.pefDevicesLoading);
  const [pefKeyword, setPefKeyword] = useState("");
  const [pefSelectedEndpoint, setPefSelectedEndpoint] = useState(null);
  const [pefSelectedDevice, setPefSelectedDevice] = useState(null);

  useEffect(() => {
    if (!pefSelectedEndpoint) return;
    setPefSelectedDevice(null);
    dispatch(RequestPefDevices(pefSelectedEndpoint.id));
  }, [pefSelectedEndpoint, dispatch]);

  useEffect(() => {
    dispatch(RequestIndexes("postfix."));
    dispatch(RequestIndexes("cf-sb1"));
  }, [dispatch]);

  const maxResultChangeHandler = (e) => {
    if (Number(e.target.value) < 100) {
      setMaxResult("100");
    } else {
      setMaxResult(e.target.value);
    }
  };

  const openLogWindowHandler = (type) => {
    var ht = 900;
    var wd = 1420;
    var features = "top=" + (window.screen.height - ht) * .2 + ",left=" + (window.screen.width - wd) * 0.84 + ",width=" + wd + ",height=" + ht + ",toolbar=no,titlebar=no,menubar=no,scrollbars=no,status=no";
    if (type === "mgw") {
      if (!mgwSelectedProcess || !mgwSelectedDevice) return;
      const index = mgwSelectedDevice.id;
      const size = Number(maxResult);
      const timeRange = getTimeRange(selectedTimeInterval.id);
      const keyword = mgwKeyword;
      const process = mgwSelectedProcess.id;
      window.open(
        `/log-window/${type}?index=${index}&size=${size}&time-range=${timeRange}&keyword=${keyword}&process=${process}`,
        "_blank",
        features,
      );
    } else if (type === "pef") {
      if (!pefSelectedEndpoint || !pefSelectedDevice) return;
      const index = pefSelectedEndpoint.id;
      const size = Number(maxResult);
      const timeRange = getTimeRange(selectedTimeInterval.id);
      const keyword = pefKeyword;
      const device = pefSelectedDevice.id;
      window.open(
        `/log-window/${type}?index=${index}&size=${size}&time-range=${timeRange}&keyword=${keyword}&device=${device}`,
        "_blank",
        features,
      );
    }
  };

  return (
    <>
      <div className="logs">
        <h1 className="logs__heading">Log Search</h1>
        <div className="logs__forms">
          <div className="logs__top-params">
            <div>
              <label>Time Interval:</label>
              <CustomSelect
                data={timeIntervalOptions}
                select={selectedTimeInterval}
                setSelected={setSelectedTimeInterval}
                width={140}
              />
            </div>
            <div>
              <label htmlFor="max-result">Max Result:</label>
              <input
                className="logs__max-result"
                type="number"
                value={maxResult}
                min={100}
                max={10000}
                step={100}
                id="max-result"
                onChange={maxResultChangeHandler}
              />
            </div>
          </div>

          <div className="logs__form-group">
            <h5>MailGateway Mail Transfer:</h5>
            <div className="logs__input-groups">
              <div className="logs__input-group">
                <label htmlFor="mgw-keyword">Keyword:</label>
                <input
                  type="text"
                  id="mgw-keyword"
                  placeholder="Type keyword"
                  value={mgwKeyword}
                  onChange={(e) => setMgwKeyword(e.target.value)}
                />
              </div>
              <div className="logs__input-group">
                <label>Process:</label>
                <CustomSelect
                  data={mgwProcessOptions}
                  select={mgwSelectedProcess}
                  setSelected={setMgwSelectedProcess}
                  width={170}
                />
              </div>
              <div className="logs__input-group">
                <label>Device:</label>
                <CustomSelect
                  data={mgwDevices.length ? mgwDevices : []}
                  select={mgwSelectedDevice}
                  setSelected={setMgwSelectedDevice}
                  width={240}
                  placeholder={mgwDevicesLoading ? "Fetching data..." : "No data."}
                  disabled={mgwDevices.length === 0}
                />
              </div>
              <button
                disabled={mgwDevices.length === 0}
                onClick={() => openLogWindowHandler("mgw")}>
                Open Log Window
              </button>
            </div>
          </div>

          <div className="logs__form-group">
            <h5>Process Error Flow:</h5>
            <div className="logs__input-groups">
              <div className="logs__input-group">
                <label htmlFor="pef-keyword">Keyword:</label>
                <input
                  type="text"
                  id="pef-keyword"
                  placeholder="Type keyword"
                  value={pefKeyword}
                  onChange={(e) => setPefKeyword(e.target.value)}
                />
              </div>
              <div className="logs__input-group">
                <label>Endpoint:</label>
                <CustomSelect
                  data={pefEndpoints}
                  select={pefSelectedEndpoint}
                  setSelected={setPefSelectedEndpoint}
                  width={220}
                  placeholder={mgwDevicesLoading ? "Fetching data..." : "No data."}
                  disabled={pefEndpoints.length === 0}
                />
              </div>
              <div className="logs__input-group">
                <label>Device:</label>
                <CustomSelect
                  data={pefDevicesLoading ? [] : pefDevices}
                  select={pefSelectedDevice}
                  setSelected={setPefSelectedDevice}
                  width={240}
                  placeholder={pefDevicesLoading ? "Fetching data..." : "No data."}
                  disabled={pefDevices.length === 0}
                />
              </div>
              <button
                disabled={pefEndpoints.length === 0 || pefDevices.length === 0}
                onClick={() => openLogWindowHandler("pef")}>
                Open Log Window
              </button>
            </div>
          </div>
        </div>
      </div>
      {modalActive ? (
        <Modal active={modalActive} setActive={setModalActive} type="log-window">
          <LogWindow />
        </Modal>
      ) : null}
    </>
  );
};

export default Logs;
